export const validateProduct = (formData) => {
  let errors = {};

  if (!formData.name?.trim()) {
    errors.name = "El nombre es obligatorio";
  }

  if (!formData.useful_life?.trim()) {
    errors.useful_life = "La vida útil es obligatoria";
  }

  if (!formData.risk?.trim()) {
    errors.risk = "El riesgo es obligatorio";
  }

  if (!formData.category_id) {
    errors.category_id = "Debe seleccionar una categoría";
  }

  return errors;
};